export default function StepDot() {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <circle id="Ellipse_423" data-name="Ellipse 423" cx="5" cy="5" r="5" fill="#5d5d5d" />
    </svg>
    )
}